export const capitalize = text => `${text[0].toUpperCase()}${text.slice(1)}`;
